(function($) {

	var $doc = $(document);
	var $win = $(window);

	var stylez = [
		{
			featureType: "all",
			elementType: "all",
			stylers: [
				{ saturation: -100 }
			]
		}
	]; 

	function initMap(mapEle) {
		var $map = jQuery(mapEle);
		var mapLat = $map.data('lat');
		var mapLng = $map.data('lng');
		var markerIcon = $map.data('pin');
		var uluru = {lat: mapLat, lng: mapLng};
		var map = new google.maps.Map($map[0], {
			zoom: 14,
			center: uluru,
			scrollwheel: false,
			navigationControl: false,
			mapTypeControl: false
		});
		var marker = new google.maps.Marker({
			position: uluru,
			map: map,
			icon: markerIcon
		});
		if ($win.width() > 767) {
			map.panBy(-250,0);
		}else{
			map.panBy(-130,0);
		}
		var mapType = new google.maps.StyledMapType(stylez, { name:"Grayscale" });    
		map.mapTypes.set('map', mapType);
		map.setMapTypeId('map');
	}

	$doc.ready(function() {
		$('.custom-map').each(function() {
			initMap($(this));
		});

		$('.video-section .outside-homepage-video a[data-play-video]').on('click' , function(event) {

			$(this).closest('.outside-homepage-video').prev('.homepage-video').find('.caption-content  a[data-play-video]').trigger('click');

			event.preventDefault();
		});
	});

})(jQuery)
